class pictureData {
  constructor(x, y) { }
  logo() {
    return 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/logo/logo.png'
  }
  fotter_logo() {
    return 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/logo/logo2.png'
  }
  banber() {
    const banberData = [{
      url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/banber/banber_7.jpg'
    },
      // {
      //     url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/banber/banber_7.jpg'
      // },
      // {
      //     url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/banber/banber_3.jpg'
      // },
      // {
      //     url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/banber/banber_4.jpg'
      // },
      // {
      //     url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/banber/banber_5.jpg'
      // },
      // {
      //     url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/banber/banber_6.jpg'
      // }

    ]
    return banberData
  }
  HomeAbout() {
    return 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Home/AboutAiLife2.png'
  }
  // HomeProduct() {
  //   const Data = [{
  //     title: 'Tests Offered <sup></sup>',
  //     url: '/#/products',
  //     // icon: '&#xe707;',
  //     icon: 'icon-chanpinyufuwu'
  //   },
  //   {
  //     title: 'AilisNGS<sup>®</sup>',
  //     url: 'https://ailis.ailifeus.com',
  //     // icon: '&#xe75c;',
  //     icon: 'icon-system-configuration',
  //   },
  //   {
  //     title: 'AilisReport<sup>®</sup>',
  //     url: 'https://report.ailifeus.com',
  //     // icon: '&#xe622;',

  //     icon: 'icon-baogao',
  //   },
  //   // {
  //   //   title: 'Alliance Genomics Platform<sup></sup>',
  //   //   url: 'https://www.ailifeus.net/',
  //   //   // icon: '&#xe608;',
  //   //   icon: 'icon-xitongguanli',
  //   // },
  //   {
  //     title: 'AiLife Tools<sup></sup>',
  //     url: '/#/tools',
  //     // icon: '&#xe934;',
  //     icon: 'icon-gongju',
  //   },
  //   ]
  //   return Data
  // }
  HomeProduct() {
    return [
      {
        title: 'Tests Offered',
        url: '/products',
        icon: 'icon-chanpinyufuwu',
        desc: 'Clinical and genomic testing services.'
      },
      {
        title: 'AilisNGS<sup>®</sup>',
        url: 'https://ailis.ailifeus.com',
        icon: 'icon-system-configuration',
        desc: 'Sequencing and analysis platform.'
      },
      {
        title: 'AilisReport<sup>®</sup>',
        url: 'https://report.ailifeus.com',
        icon: 'icon-baogao',
        desc: 'Reporting and interpretation workflows.'
      },
      {
        title: 'AiLife Tools',
        url: '/tools',
        icon: 'icon-gongju',
        desc: 'Bioinformatics tools for research.'
      }
    ];
  }
  HomeTeam() {
    const HomeTeamData = [
      {
        title: "Theodore Chiang, MS, BS",
        secondaryTitle: "Bioinformatics/ IT Director",
        introduce: "Ted's career spans over 20 years of Bioinformatics technology and experience. Prior to AiLife, he contributed to numerous clinical and sequencing projects at the Human Genome Center at Baylor College of Medicine (WGL, eMerge) and at SickKids Hospital (Toronto). Ted is a graduate from Georgia Tech (Bioinformatics, MSc) and University of Toronto (Medical Genetics, MSc). He also holds a BSc in Biochemistry from McGill University.",
        link: '/about/people',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Home/p2.png'
      },
      {
        title: "Sandra Peacock, MS, CGC",
        secondaryTitle: "Genetic Counselor",
        introduce: "Sandra has more than 25 yrs experience as a board-certified genetic counselor, beginning as a prenatal clinical GC then moving into a career as a lab GC, including more than 17 yrs at Baylor Genetics prior to joining AiLife. She has expertise in all areas of prenatal studies, as well as in postnatal exome and genome studies. She has a strong interest in education for upcoming genetic clinicians and laboratorians, having led the genetics laboratory rotation for local genetic counseling training programs for more than 10 yrs, and participating in genetics fellow training. Sandra has also served on numerous National Society of Genetic Counselors’ volunteer committees, including those for educational and laboratory issues.",
        link: '/about/people',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Home/Sandra.png'
      },
      {
        title: "Amber Pursley, MS, CGC",
        secondaryTitle: "Genetic Counselor",
        introduce: "",
        link: '/about/people',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Home/p11.png'
      },
      {
        title: "Xia Wang, PhD, FACMG",
        secondaryTitle: "Co-Founder, CDO",
        introduce: "Dr. Wang is a clinical molecular geneticist accredited by the American Board of Medical Genetics and Genomics (ABMGG), former director of the next-generation sequencing and bioinformatics at Baylor Genetics, and assistant professor at the Department of Human and Molecular Genetics at Baylor College of Medicine. Dr. Wang is specialized in the interpretation of the next-generation sequencing data for genetic diseases, and the development of bioinformatics solutions. His research interests include the discovery of novel disease-causing genes, in-depth interpretation of exome data, and molecular genetic studies of eye diseases. Dr. Wang has published papers in several top academic journals including Nature Genetics, the American Journal of Human Genetics, Genetics in Medicine, Journal of Medical Genetics, and Human Mutation.",
        link: '/about/people',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Home/p1.png'
      },
      {
        title: "Yaping Yang, PhD, FACMG",
        secondaryTitle: "Founder & CEO",
        introduce: "Dr. Yang is an ABMGG certified clinical molecular geneticist with over 20 years of experience in genomic sequencing, clinical NGS reporting and new disease gene discoveries. Previously at Baylor College of Medicine and Baylor Genetics, Dr. Yang led the clinical exome, which is one of first clinical exome program in the world, for seven years. Her team has made thousands of molecular diagnoses and numerous new gene discoveries. Dr. Yang produced multiple publications in high impact journals including the New England Journal of Medicine, JAMA, Nature Genetics, the American Journal of Human Genetics, and Genetics in Medicine. Those publications documented the clinical utility of clinical NGS, the impact of NGS on medical management of patients, as well as new disease genes and the underlining disease mechanisms.",
        link: '/about/people',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Home/people0.png'
      },



    ]
    return HomeTeamData
  }
  HomeTeamServe() {
    const HomeTeamData = [
      {
        title: "Cindy Pleckham, BS",
        secondaryTitle: "Administrator",
        introduce: "Ms. Pleckham has over 35 years of high-level administrative experience in the healthcare industry which includes the hospital, academic and corporate setting. She is a former Baylor Genetics employee where she directly supported the genetics directors and their laboratories. Her work experience includes medical billing, revenue cycle management, coding, and credentialing.",
        link: '/about/people',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Home/p7.png'
      },
      {
        title: "Angelica Ramirez",
        secondaryTitle: "Supervisor, Laboratory Receiving",
        // introduce: "Angelica has high quality managerial experience in the laboratory industry which includes toxicology, hematology, microbiology, and cytogenetics laboratories. She provides both administrative and technical support for the smooth running of laboratory operations. ",
        introduce: "Angelica has over 10 years of experience and high-quality managerial and pre-analytical expertise in the laboratory industry, including toxicology, hematology, microbiology, and cytogenetics. Skilled in providing pre-analytical, administrative, and technical support to ensure the smooth and efficient operation of laboratory processes.",
        link: '/about/people',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Home/p8.png'
      },


      {
        title: "Rob Schiek, BS",
        secondaryTitle: "VP, Sales and Marketing",
        introduce: "Rob is a tenured sales professional with 17 years of experience in the diagnostics space, spending time both in account management and leadership. His knowledge and strengths are specifically with genetic testing, and interests lie in the growing utilization of testing in pharmacogenetics and companion diagnostics.",
        link: '/about/people',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Home/p9.png'
      },
      {
        title: "Derek Stevens, MS, MA",
        secondaryTitle: "VP, Sales and Marketing",
        introduce: "Derek is a tenured sales and marketing professional with 25 years of pharmaceutical and genetics industry experience. He has built his career around working with customers to develop strategies that are focused, yet flexible, with metrics to define success and also the need to pivot based on data. Having launched the first industry-sponsored genetic testing programs, Derek has developed true expertise and thought leadership to bring programs to life that benefit the rare disease community, as well as achieve sponsor objectives. Derek also began his career on the research bench and he continues to support customers with decades of clinical trial and research study experience. His passion for this industry is driven by his desire to empower patients through quality diagnostic testing and other resources that lead to better patient management and outcomes.",
        link: '/about/people',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Home/p10.png'
      },


    ]
    return HomeTeamData
  }
  footer() {
    const footerData = [{
      url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/footer/0.png'
    },
    {
      url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/footer/1.png'
    },
    {
      url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/footer/2.png'
    },
    {
      url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/footer/3.png'
    },
    {
      url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/footer/4.png'
    },
    {
      url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/footer/5.png'
    },

    ]
    return footerData
  }
  footerIcon() {
    const footerData = [{
      icon: '&#xe600;',
      link: 'https://twitter.com/AilifeD',
      url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/footer/icon/1.png'
    },
    {
      icon: '&#xe65a;',
      link: 'https://www.facebook.com/AiLife-Diagnostics-104356561443247',
      url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/footer/icon/2.png'
    },
    {
      icon: '&#xe637;',
      link: 'https://www.linkedin.com/company/ailifeus',
      url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/footer/icon/3.png'
    },


    ]
    return footerData
  }
  products() {
    return [{
      id: 1,
      url: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/0.png",
      title: "How to Order",
      ip: "/products/order",
      details: ''

    },

    {
      id: 2,
      url: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/page/huaxueshiyan.png",
      title: 'Product Brochures',
      ip: "/products/Brochures",
      details: ''
    },
    {
      id: 3,
      url: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/2.png",
      title: 'AilisNGS',
      ip: "/products/ngs",
      details: ''
    },
    {
      id: 4,
      url: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/page/jiyin.png",
      title: 'Exome sequencing (WES)',
      ip: "/products/wes",
      details: ''
    },
    {
      id: 5,
      url: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/page/shiyan.png",
      title: 'Gene Panels',
      ip: "/products/gene",
      details: ''
    },
    {
      id: 6,
      url: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/page/shiyan1.png",
      title: 'Low Pass WGS',
      ip: "/products/lowWgs",
      details: ''
    },
    {
      id: 7,
      url: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/page/shiyan2.png",
      title: 'Mito Genome Sequencing',
      ip: "/products/mito",
      details: ''
    },
    {
      id: 8,
      url: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/page/shiyan3.png",
      title: 'NGS Data Reanalysis',
      ip: "/products/reanalysis",
      details: ''
    },
    {
      id: 9,
      url: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/10.png",
      title: 'WGS',
      ip: "/products/wgs",
      details: ''
    },
    {
      id: 10,
      url: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/10.png",
      title: 'F8 Inversions',
      ip: "/products/f8",
      details: ''
    },
    ]
  }

  order() {
    return [
      {
        icon: "icon-wenjian",
        title: "AiLife TRF and Consent",
        // description: "AiLife TRF and Consent",
        link: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/order/AiLife%2BTRF%2Band%2BConsent.pdf", // 示例文件链接
      },
      // {
      //   icon: "icon-jurassic_submit-form",
      //   title: "填写表格",
      //   description: "Specimen Requirements and Shipping Instructions",
      //   link: "https://ailiswebsite.oss-cn-hangzhou.aliyuncs.com/file/pdf/Products/order/AiLIfe%20Genetic%20Testing%20Consent%20Form.pdf", // 示例文件链接
      // },
      {
        icon: "icon-a-hezibaoguowuliubaozhuanghuowu",
        title: "Specimen Requirements and Shipping Instructions",
        // description: "Specimen Requirements and Shipping Instructions",
        link: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/order/Specimen+Requirements+and+Shipping+Instructions.pdf", // 示例文件链接
      },
    ]
  }
  brochures() {
    return [
      {
        title: 'AiLife Rapid Whole Genome Sequencing',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/Brochures/AiLife_NICU_Rapid+WGS.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Product+Brochures/AiLife+Rapid+Whole+Genome+Sequencing.png'
      },
      {
        title: 'AiLife Rapid Whole Exome Sequencing',
        // url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/Brochures/AiLife_NICU_V7.pdf',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/wes/AiLife_NICU_Rapid+WES.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Product+Brochures/AiLife+Rapid+Whole+Exome+Sequencing.png'
      },
      {
        title: 'AiLife Whole Exome Sequencing',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/Brochures/AiLife_RegularWES.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Product+Brochures/AiLife+Whole+Exome+Sequencing.png'
      },
      {
        title: 'AiLife Health Screening ',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/Brochures/AiLife%20Health%20Screening.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Product+Brochures/AiLife+Health+Screening.png'
      },
      {
        title: 'AilisNGS',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/Brochures/AilisNGS.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Product+Brochures/AilisNGS.png'
      },

      {
        title: 'Genome-wide CNV Analysis',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/Brochures/AiLife_CNVseq.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Product+Brochures/Genome-wide+CNV+Analysis.png'
      },



    ]
  }
  ngs() {
    const newData = [{
      title: 'AilisNGS',
      url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/NGS/AilisNGS.pdf',
      img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/ngs/ngs_1.jpg'
    },]
    return newData
  }
  wes() {
    const newData = [{
      title: 'AiLife_Rapid WES',
      // url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/wes/AiLife_NICU_V7.pdf',
      url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/wes/AiLife_NICU_Rapid+WES.pdf',
      img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/WES/wes_1.jpg'
    },
    {
      title: 'AiLife_Regular WES',
      url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/wes/AiLife_RegularWES.pdf',
      img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/WES/wes_2.jpg'
    },
    {
      title: 'AiLife Health Screening',
      url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/wes/AiLife%20Health%20Screening.pdf',
      img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/WES/wes_3.jpg'
    },
    ]
    return newData
  }
  gene() {
    const newData = [
      {
        type: 'Blood',
        typeColor: '#f5576c',
        // typeColor: 'background-color: #ecf5ff;color: #409eff;border: 1px solid #409eff; ',
        title: 'Anemia',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/Anemia+NGS+Panel+Infosheet.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/gene/gene_1.jpg',
        value: 137
      },
      {
        type: 'Blood',
        typeColor: '#f5576c',
        // typeColor: 'background-color: #ecf5ff;color: #409eff;border: 1px solid #409eff; ',
        title: 'Bleeding Disorder ',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/Bleeding+Disorder+NGS+Panel+Infosheet.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/gene/gene_1.jpg',
        value: 83
      },
      {
        type: 'Blood',
        typeColor: '#f5576c',
        // typeColor: 'background-color: #ecf5ff;color: #409eff;border: 1px solid #409eff; ',
        title: 'Bone Marrow Failure ',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/Bone+marrow+failure+Infosheet.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/gene/gene_1.jpg',
        value: 171
      },
      {
        type: 'Blood',
        typeColor: '#f5576c',
        // typeColor: 'background-color: #ecf5ff;color: #409eff;border: 1px solid #409eff; ',
        title: 'Platelet Disease',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/Platelet+Disease+NGS+Panel+Infosheet.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/gene/gene_1.jpg',
        value: 52
      },
      {
        type: 'Blood',
        typeColor: '#f5576c',
        // typeColor: 'background-image: linear-gradient(to right, #6a11cb 0%, #2575fc 100%);',
        // typeColor: 'background-color: #ecf5ff;color: #409eff;border: 1px solid #409eff; ',
        title: 'Fanconi Anemia  ',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/Fanconi+anemia+Infosheet.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/gene/gene_1.jpg',
        value: 27
      },
      {
        type: 'Cardiovascular',
        typeColor: '#037ef3',
        // typeColor: 'background-image: linear-gradient(-225deg, #3D4E81 0%, #5753C9 48%, #6E7FF3 100%);',
        // typeColor: ' background- color: #f0f9eb;border: 1px solid #67c23a;color: #67c23a; ',
        title: 'Aortopathy and Connective Tissue Disorders',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/Aortopathy%20and%20Connective%20Tissue%20DisordersInfoSheet.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/gene/gene_2.jpg',
        value: 56
      },
      {
        type: 'Cardiovascular',
        typeColor: '#037ef3',
        // typeColor: 'background-image: linear-gradient(-225deg, #3D4E81 0%, #5753C9 48%, #6E7FF3 100%);',
        // typeColor: ' background- color: #f0f9eb;border: 1px solid #67c23a;color: #67c23a; ',
        title: 'Arrhythmia',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/Comprehensive%20Arrhythmia%20Panel%20InfoSheet.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/gene/gene_3.jpg',
        value: 40
      },
      {
        type: 'Cardiovascular',
        typeColor: '#037ef3',
        // typeColor: 'background-image: linear-gradient(to top, #48c6ef 0%, #6f86d6 100%);',
        // typeColor: ' background- color: #f0f9eb;border: 1px solid #67c23a;color: #67c23a; ',
        title: 'Cardiomyopathy',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/comprehensive%20cardiomyopathy%20panel%20InfoSheet%20(1).pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/gene/gene_4.jpg',
        value: 106
      },
      {
        type: 'Cardiovascular',
        typeColor: '#037ef3',
        // typeColor: 'background-image: linear-gradient(to top, #48c6ef 0%, #6f86d6 100%);',
        // typeColor: ' background- color: #f0f9eb;border: 1px solid #67c23a;color: #67c23a; ',
        title: 'Familial Hypercholesterolemia',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/Familial%20HypercholesterolemiaInfoSheet.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/gene/gene_5.jpg',
        value: 6
      },
      {
        type: 'Cardiovascular',
        typeColor: '#037ef3',
        // typeColor: 'background-image: linear-gradient(to top, #48c6ef 0%, #6f86d6 100%);',
        // typeColor: ' background- color: #f0f9eb;border: 1px solid #67c23a;color: #67c23a; ',
        title: 'RASopathy/Noonan syndrome',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/RASopathies_NSInfoSheet.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/gene/gene_6.jpg',
        value: 26
      },
      {
        type: 'Cardiovascular',
        typeColor: '#037ef3',
        // typeColor: 'background-image: linear-gradient(to top, #48c6ef 0%, #6f86d6 100%);',
        // typeColor: ' background- color: #f0f9eb;border: 1px solid #67c23a;color: #67c23a; ',
        title: 'Congenital Heart Defect',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/Congenital%20Heart%20Defect%20Panel%20InfoSheet.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/gene/gene_7.jpg',
        value: 127
      },
      {
        type: 'Ciliopathy',
        typeColor: '#00aeff',
        // typeColor: 'background-image: linear-gradient(-20deg, #b721ff 0%, #21d4fd 100%);',
        // typeColor: 'background- color: #21d4fd;border: 1px solid #b721ff;color: #b721ff; ',
        title: 'Comprehensive Ciliopathy Panel',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/Ciliopathy+Infosheet.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/gene/gene_7.jpg',
        value: 128
      },
      {
        type: 'Ciliopathy',
        typeColor: '#00aeff',
        // typeColor: 'background- color: #21d4fd;border: 1px solid #b721ff;color: #b721ff; ',
        title: 'Heterotaxy',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/Heterotaxy+Infosheet.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/gene/gene_7.jpg',
        value: 44
      },

      {
        type: 'Connective Tissue',
        typeColor: '#c43a30',
        // typeColor: 'background-image: linear-gradient(to top, #5f72bd 0%, #9b23ea 100%);',
        // typeColor: 'background- color: #9b23ea;border: 1px solid #5f72bd;color: #5f72bd; ',
        title: 'Connective Tissue Disorder ',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/Connective+tissue+diseases+Infosheet.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/gene/gene_7.jpg',
        value: 89
      },
      {
        type: 'Connective Tissue',
        typeColor: '#c43a30',
        // typeColor: 'background-image: linear-gradient(to top, #5f72bd 0%, #9b23ea 100%);',
        // typeColor: 'background- color: #9b23ea;border: 1px solid #5f72bd;color: #5f72bd; ',
        title: 'Osteogenesis Imperfecta ',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/Osteogenesis+imperfecta+InfoSheet.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/gene/gene_7.jpg',
        value: 37
      },
      {
        type: 'Ear',
        typeColor: '#BDC581',
        // typeColor: 'background-image: linear-gradient(to top, #4481eb 0%, #04befe 100%);',
        // typeColor: 'background- color: #04befe;border: 1px solid #4481eb;color: #4481eb; ',
        title: 'Hearing Loss',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/hearing%20loss%20panel.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/gene/gene_12.jpg',
        value: 146
      },
      {
        type: 'Endocrine systems',
        typeColor: '#075aaa',
        // typeColor: 'background-image: linear-gradient(to right, #0acffe 0%, #495aff 100%);',
        // typeColor: 'background- color: #330867;border: 1px solid #30cfd0;color: #30cfd0; ',

        title: 'Diabetes and Obesity',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/Diabetes%20and%20Obesity%20Panel.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/gene/gene_8.jpg',
        value: 34
      },
      {
        type: 'Eye',
        typeColor: '#fe5000',
        // typeColor: 'background-image: linear-gradient(to top, #48c6ef 0%, #6f86d6 100%);',
        // typeColor: 'background- color: #d43f8d;border: 1px solid #0250c5;color: #0250c5; ',
        title: 'Eye Disorders*',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/eye%20disorder%20panel.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/gene/gene_9.jpg',
        value: 608
      },
      {
        type: 'Hereditary Cancer',
        typeColor: '#005670',
        title: 'Hereditary Cancer',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/Hereditary+Cancer+NGS+Panel+Infosheet.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/gene/gene_13.jpg',
        value: 125
      },
      {
        type: 'Liver',
        typeColor: '#52c41a',
        title: 'Liver Disease',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/Liver+DiseaseInfoSheet+(126).pdf',
        value: 126
      },
      {
        type: 'Lysosome',
        typeColor: '#fa8c16',
        title: 'Lysosomal Storage Disease',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/Lysosomal+Storage+DiseaseInfoSheet+(149).pdf',
        value: 149
      },


      {
        type: 'Immune system',
        typeColor: '#48c6ef',
        // typeColor: 'background-image: linear-gradient(to right, #00dbde 0%, #fc00ff 100%);',
        // typeColor: 'background- color: #537895;border: 1px solid #09203f;color: #09203f; ',
        title: 'Autoimmunity and Autoinflammation',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/Autoinflammatory%20Autoimmune%20Disease%20Gene%20Panel.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/gene/gene_1.jpg',
        value: 104
      },
      {
        type: 'Immune system',
        typeColor: '#48c6ef',
        title: 'PID and Cytopenia',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/PID+and+Cytopenia+NGS+Panel+InfoSheet+(640).pdf',
        value: 640
      },
      {
        type: 'Neurologic',
        typeColor: '#a51890',
        title: 'Parkinson Alzheimer Dementia',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/Parkinson-Alzheimer-Dementia%20Panel.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/gene/gene_14.jpg',
        value: 47
      },
      {
        type: 'Neurologic',
        typeColor: '#a51890',
        title: 'Myopathy',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/MyopathyInfoSheet+(96)+genes.pdf',
        value: 96
      },
      {
        type: 'Neurologic',
        typeColor: '#a51890',
        title: 'Muscular Dystrophy',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/Muscular+Dystrophy+InfoSheet+(132).pdf',
        value: 132
      },
      {
        type: 'PGX',
        typeColor: '#3e1f25',
        title: 'Pharmacogenomics Testing',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/AiLife+PGX+TRF.pdf',
        value: 22
      },
      {
        type: 'Renal',
        typeColor: '#009f4d',
        // typeColor: 'background-image: linear-gradient(to top, #48c6ef 0%, #6f86d6 100%);',
        // typeColor: 'background- color: #485563;border: 1px solid #29323c;color: #29323c; ',
        title: 'Renal Disease*',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/Renal+disease+InfoSheet.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/gene/gene_14.jpg',
        value: 175
      },
      {
        type: 'Skeletal',
        typeColor: '#84bd00',
        // typeColor: 'background-image: linear-gradient(-225deg, #B7F8DB 0%, #50A7C2 100%);',
        // typeColor: 'background- color: #764ba2;border: 1px solid #667eea;color: #667eea; ',
        title: 'Skeletal Dysplasia ',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/Skeletal+dysplasia+Infosheet.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/gene/gene_14.jpg',
        value: 174
      },


      {
        type: 'Health Screening',
        typeColor: '#0077c8',
        // typeColor: 'background-image: linear-gradient(-225deg, #65379B 0%, #886AEA 53%, #6457C6 100%);',
        // typeColor: 'background- color: #6457C6;border: 1px solid #65379B;color: #65379B; ',
        title: 'Health Screening (Basic)',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/Genes+for+health+screeningBasic.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/gene/gene_10.jpg',
        value: 148
      },
      {
        type: 'Health Screening',
        typeColor: '#0077c8',
        // typeColor: 'background-image: linear-gradient(-225deg, #65379B 0%, #886AEA 53%, #6457C6 100%);',
        // typeColor: 'background- color: #6457C6;border: 1px solid #65379B;color: #65379B; ',
        title: 'Health Screening (Expanded)',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/gene/Genes+for+health+screening+316+genes+AiLife.pdf',
        img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/gene/gene_11.jpg',
        value: 316
      },


    ]
    return newData
  }
  wgs() {
    const newData = [{
      title: 'AiLife_CNVseq ',
      url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/wgs/AiLife_CNVseq.pdf',
      img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Products/wgs/wgs_1.jpg'
    },

    ]
    return newData
  }
  about() {
    const aboutData = [{
      id: 1,
      url: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/about/about_0.png",
      title: "Our People",
      ip: "/about/people",
      details: ''

    },
    {
      id: 1,
      url: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/about/page/shiyanqicai.png",
      title: 'Our Mission',
      ip: "/about/mission",
      details: ''
    },
    {
      id: 2,
      url: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/about/page/shiyanshi.png",
      title: 'Our Licenses',
      ip: "/about/licenses",
      details: ''
    },
    {
      id: 3,
      url: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/about/page/shiyanshishebei.png",
      title: 'Our Publications',
      ip: "/about/publications",
      details: ''
    }, {
      id: 4,
      url: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/about/about_4.png",
      title: 'Contact Us',
      ip: "/about/cantact",
      details: ''
    },

    ]
    return aboutData
  }
  aboutPeople() {
    const Data = [
      {

        title: 'Ted Chiang, M.S',
        secondeTitle: 'Bioinformatics/ IT Director',
        threeTitle: '',
        url: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/about/people/p2.png",
        details: "Ted's career spans over 20 years of Bioinformatics technology and experience. Prior to AiLife, he contributed to numerous clinical and sequencing projects at the Human Genome Center at Baylor College of Medicine (WGL, eMerge) and at SickKids Hospital (Toronto). Ted is a graduate from Georgia Tech (Bioinformatics, MSc) and University of Toronto (Medical Genetics, MSc). He also holds a BSc in Biochemistry from McGill University.",
      },
      // {
      //   title: "Magalie Leduc, PhD, FACMG",
      //   secondeTitle: "VP of Clinical Genomics",
      //   details: "Dr. Leduc is a clinical molecular geneticist accredited by the American Board of Medical Genetics and Genomics (ABMGG) with over 20 years of experience in the genomic space, including 12 years in clinical laboratories. Dr. Leduc joined Baylor College of Medicine during the early days of the implementation of exome sequencing in the clinic, which led to diagnoses of thousands of patients. She then held positions at Baylor Genetics, Veritas Genetics and GeneDx. Dr. Leduc has led and managed several sequencing programs, and she brings expertise in variant classification, exome and genome sequencing, as well as NGS testing for cancer and cardiovascular diseases. She is a CAP inspector and led the implementation of quality management programs and operations in high complexity laboratories. She has a keen interest in implementing solutions to provide high quality results to guide patient care, and expanding the use of genetic testing to a broader audience to make informed health care decisions.",
      //   threeTitle: '',
      //   url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/about/people/Magalie.png'
      // },
      {
        title: 'Cindy Pleckham, BS',
        secondeTitle: 'Administrator',
        threeTitle: '',
        url: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/about/people/p7.png",
        details: 'Ms. Pleckham has over 35 years of high-level administrative experience in the healthcare industry which includes the hospital, academic and corporate setting. She is a former Baylor Genetics employee where she directly supported the genetics directors and their laboratories. Her work experience includes medical billing, revenue cycle management, coding, and credentialing.'
      },
      {
        title: 'Angelica Ramirez',
        secondeTitle: 'Supervisor, Laboratory Receiving',
        threeTitle: '',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/Home/p8.png',
        // details: 'Angelica has high quality managerial experience in the laboratory industry which includes toxicology, hematology, microbiology, and cytogenetics laboratories. She provides both administrative and technical support for the smooth running of laboratory operations.',
        details: 'Angelica has over 10 years of experience and high-quality managerial and pre-analytical expertise in the laboratory industry, including toxicology, hematology, microbiology, and cytogenetics. Skilled in providing pre-analytical, administrative, and technical support to ensure the smooth and efficient operation of laboratory processes.'
      },
      {
        title: "Rob Schiek, BS",
        secondeTitle: "VP, Sales and Marketing",
        threeTitle: '',
        url: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/about/people/p9.png",
        details: 'Rob is a tenured sales professional with 17 years of experience in the diagnostics space, spending time both in account management and leadership. His knowledge and strengths are specifically with genetic testing, and interests lie in the growing utilization of testing in pharmacogenetics and companion diagnostics.'
      },

      {
        title: "Sandra Peacock, MS, CGC",
        secondeTitle: "Genetic Counselor",
        details: "Sandra has more than 25 yrs experience as a board-certified genetic counselor, beginning as a prenatal clinical GC then moving into a career as a lab GC, including more than 17 yrs at Baylor Genetics prior to joining AiLife. She has expertise in all areas of prenatal studies, as well as in postnatal exome and genome studies. She has a strong interest in education for upcoming genetic clinicians and laboratorians, having led the genetics laboratory rotation for local genetic counseling training programs for more than 10 yrs, and participating in genetics fellow training. Sandra has also served on numerous National Society of Genetic Counselors’ volunteer committees, including those for educational and laboratory issues.",
        threeTitle: '',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/about/people/Sandra.png'
      },

      {
        title: "Derek Stevens, MS, MA",
        secondeTitle: "VP, Sales and Marketing",
        details: "Derek is a tenured sales and marketing professional with 25 years of pharmaceutical and genetics industry experience. He has built his career around working with customers to develop strategies that are focused, yet flexible, with metrics to define success and also the need to pivot based on data. Having launched the first industry-sponsored genetic testing programs, Derek has developed true expertise and thought leadership to bring programs to life that benefit the rare disease community, as well as achieve sponsor objectives. Derek also began his career on the research bench and he continues to support customers with decades of clinical trial and research study experience. His passion for this industry is driven by his desire to empower patients through quality diagnostic testing and other resources that lead to better patient management and outcomes.",
        threeTitle: '',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/about/people/p10.png'
      },
      {
        title: "Amber Pursley, MS, CGC",
        secondeTitle: "Genetic Counselor",
        details: "",
        threeTitle: '',
        url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/about/people/p11.png'
      },

      {
        title: 'Xia Wang, PhD, FACMG',
        secondeTitle: 'Co-Founder, CDO',
        threeTitle: '',
        url: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/about/people/p1.png",
        details: 'Dr. Wang is a clinical molecular geneticist accredited by the American Board of Medical Genetics and Genomics (ABMGG), former director of the next-generation sequencing and bioinformatics at Baylor Genetics, and assistant professor at the Department of Human and Molecular Genetics at Baylor College of Medicine. Dr. Wang is specialized in the interpretation of the next-generation sequencing data for genetic diseases, and the development of bioinformatics solutions. His research interests include the discovery of novel disease-causing genes, in-depth interpretation of exome data, and molecular genetic studies of eye diseases. Dr. Wang has published papers in several top academic journals including Nature Genetics, the American Journal of Human Genetics, Genetics in Medicine, Journal of Medical Genetics, and Human Mutation'
      },
      {
        title: 'Yaping Yang, PhD, FACMG',
        secondeTitle: 'Founder & CEO',
        threeTitle: '',
        url: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/about/people/people0.png",
        details: 'Dr. Yang is an ABMGG certified clinical molecular geneticist with over 20 years of experience in genomic sequencing, clinical NGS reporting and new disease gene discoveries. Previously at Baylor College of Medicine and Baylor Genetics, Dr. Yang led the clinical exome, which is one of first clinical exome program in the world, for seven years. Her team has made thousands of molecular diagnoses and numerous new gene discoveries. Dr. Yang produced multiple publications in high impact journals including the New England Journal of Medicine, JAMA, Nature Genetics, the American Journal of Human Genetics, and Genetics in Medicine. Those publications documented the clinical utility of clinical NGS, the impact of NGS on medical management of patients, as well as new disease genes and the underlining disease mechanisms.',
      },










    ]
    return Data
  }
  ToolsData() {
    const Data = [{
      id: 1,
      url: "",
      title: "",
      ip: "#",
      details: ''
    },

    {
      id: 2,
      url: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/tools/page/1.png",
      title: "AutoHPO",
      ip: "/tools/AutoHPO",
      details: ''
    },
    {
      id: 3,
      url: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/tools/page/2.png",
      title: 'DiseaseRK',
      ip: "/tools/DiseaseRK",
      details: ''
    },
    {
      id: 4,
      url: "",
      title: '',
      ip: "#",
      details: ''
    },
    ]
    return Data
  }

  aboutLicenses() {
    const Data = [{
      title: 'CLIA# 45D2157396',
      img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/about/licenses/img1.png',
      url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/about/licenses/CLIA%20Certificate.pdf'
    },

    {
      title: 'CAP # 8433758',
      img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/about/licenses/img2.png',
      url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/about/licenses/CAP%20Certificate.pdf'
    },
      // {
      //     title: 'California License CDS00800962',
      //     img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/about/licenses/licenses_3.jpg',
      //     url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/about/licenses/California%20License.pdf'
      // },
      // {
      //     title: 'Maryland Permit 3040',
      //     img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/about/licenses/licenses_4.jpg',
      //     url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/about/licenses/Maryland%20permit.pdf'
      // },
      // {
      //     title: 'Pennsylvania License 37225',
      //     img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/about/licenses/licenses_5.jpg',
      //     url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/about/licenses/Pennsylvania%20permit.pdf'
      // },
      // {
      //     title: 'Rhode Island License LCO01327',
      //     img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/about/licenses/licenses_6.jpg',
      //     url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/about/licenses/Rhode%20Island%20License.pdf'
      // },


    ]
    return Data
  }



  covid() {
    const covidData = [{
      title: 'COVID-19 Test Requisition',
      url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/covid/COVID-19+Test+Requisition.pdf',
      img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/covid/covid_3.jpg'
    },
      // {
      //   title: 'COVID-19 AntibodyInfo',
      //   url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/covid/COVID-19%20AntibodyInfo.pdf',
      //   img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/covid/covid_1.jpg'
      // },

      // {
      //   title: 'COVID-19 Nucleic Acid and Antigen Test Info',
      //   url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/covid/AiLifeCovidAgPCR%20One%20page.pdf',
      //   img: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/covid/covid_4.jpg'
      // }
    ]
    return covidData
  }
  media() {
    return [{ title: "AiLife Diagnostics Achieves HITRUST Certification", description: "", link: "/media/news3", color: "linear-gradient(135deg, #4e54c8, #8f94fb)" },
    { title: "ASHG 2019 Meeting, Houston", description: "", link: "/media/news1", color: "linear-gradient(135deg, #ff7eb3, #ff758c)" },
    ]
  }
  mediaBlogs() {
    return [{ title: "COVID-19 testing", description: "", link: "/media/blog3", color: "linear-gradient(135deg, #667eea, #764ba2)" },
    { title: "Mappability in Calling CNVs in Exomes", description: ".", link: "/media/blog1", color: "linear-gradient(135deg, #ff9966, #ff5e62)" },
    { title: "Public Perceptions of Genomic Data Sharing", description: "", link: "/media/blog2", color: "linear-gradient(135deg, #36d1dc, #5b86e5)" },
    ]

  }
  mediaData() {
    const Data = [{
      content: 'The company presented research on multiple topics ranging from using Atlas-CNV to identify deletions in clinical exomes, to the challenges of recognizing phenotype-genotype correlations in prenatal exome sequencing. Overall, the company had one platform presentation and four posters. The platform presentation, introducing whole genome sequencing as an alternative to chromosomal microarray analysis, generated interest among the attendees and provided insight into the company’s research interests.',
      url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/media/message/houston_3.jpg',

    },
    {
      content: 'Additionally, Dr. Wang, company Co-Founder and the Chief Diagnostic Officer, presented at the BGI lunch seminar. Dr. Wang’s talk titled: “Clinical NGS: Exome vs Genome Sequencing” discussed the technical aspects of whole exome and whole genome sequencing and navigated practical challenges in the field. He addressed the benefits and drawbacks of each approach and how they can be used in the clinical setting.',
      url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/media/message/houston_1.jpg',
    },
    {
      content: 'Ailife Diagnostics also hosted an exhibitor booth at the meeting. The booth was well attended by meeting attendees. Company representatives answered questions, provided demos of the company’s variant interpretation web tool and increased company visibility.',
      url: 'https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/media/message/houston_2.jpg',

    }
    ]
    return Data
  }
  CompanyInformation() {
    return [
      { term: "1920 Country Pl Pkwy, Suite 100, Pearland, TX 77584", routeip: "/about/cantact" },
      { term: "Phone: (346) 342-1802 ", routeip: "tel:(346) 342-1802" },
      {
        term: "contact@ailifeus.com",
        routeip: "mailto:contact@ailifeus.com",
      },
      {
        term: "Client Services: 8:30 AM – 5:30 PM CDT, Monday – Friday",
        routeip: "",
      },
      {
        term: "Sample Receiving: 8:30 AM – 5:30 PM CDT, Monday – Saturday",
        routeip: "",
      },
    ]
  }
  footerList() {
    return [
      {
        title: "Products & Services",
        items: [
          { term: "How to Order", routeip: "/products/order" },
          { term: "Product Brochures", routeip: "/products/Brochures" },
          { term: "AilisNGS", routeip: "/products/ngs" },
          { term: "Exome Sequencing (WES)", routeip: "/products/wes" },
          { term: "Gene Panels", routeip: "/products/gene" },
          { term: "Low-Pass WGS", routeip: "/products/lowWgs" },
          { term: "Mito Genome Sequencing", routeip: "/products/mito" },
          { term: "NGS Data Reanalysis", routeip: "/products/reanalysis" },
          { term: "WGS", routeip: "/products/wgs" },
          { term: "F8 Inversions", routeip: "/products/f8" },
          // { term: "Fragile X Repeat Expansion", routeip: "/products/Fragile" },
          { term: "Repeat Expansion Disorders", routeip: "/products/Repeat" },
        ]
      },
      {
        title: "About Us",
        items: [
          { term: "Our People", routeip: "/about/people" },
          { term: "Our Mission", routeip: "/about/mission" },
          { term: "Our Licenses", routeip: "/about/licenses" },
          { term: "Our Publications", routeip: "/about/publications" },
          { term: "Contact Us", routeip: "/about/cantact" },
          { term: "Privacy Policy", routeip: "/about/privacy" }
        ]
      },
      {
        title: "Media",
        items: [{ term: "Company News ", routeip: "/media" }]
      },
      {
        title: "Contact Us",
        items: this.CompanyInformation()
      },
      {
        title: "",
        items: []
      }
    ]
  }
}

const picture = new pictureData()
export default picture



// WEBPACK FOOTER //
// ./src/utils/img.js